/**
 * CMDB / Elements Connect options often carry an `attributes` array.
 * This util normalizes access to common attributes by id.
 */

const normalizeId = (v) => String(v ?? '');

export const getOptionAttributeFirstDisplayValue = (option, objectTypeAttributeId) => {
  console.log('[getOptionAttributeFirstDisplayValue] option', option, objectTypeAttributeId);

  const attrs = option?.attributes;
  if (!Array.isArray(attrs) || !attrs.length) return undefined;

  const wantedId = normalizeId(objectTypeAttributeId);
  const targetAttr = attrs.find((attr) => {
    const attrId = normalizeId(attr?.objectTypeAttributeId ?? attr?.id);
    return attrId === wantedId;
  });

  const firstValue = targetAttr?.objectAttributeValues?.[0];
  return firstValue?.displayValue ?? firstValue?.value;
};

// Convention used in this project:
// - 259: "type"
// - 304: "image url"
export const getOptionTypeLabel = (option) => getOptionAttributeFirstDisplayValue(option, '259');
export const getOptionImageUrl = (option) => getOptionAttributeFirstDisplayValue(option, '304');


